import React from 'react';

function MainFooter(props) {
    return (
        <div className='flex items-center'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <circle cx="12" cy="12" r="4"></circle>
            </svg> 30558461515
        </div>
    );
}

export default MainFooter;